import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PasswordReset from '../components/PasswordReset';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  // Redirect to dashboard if user is already authenticated
  useEffect(() => {
    if (currentUser) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/dashboard');
    } catch (error) {
      setError('Failed to log in: ' + error.message);
    }
    
    setLoading(false);
  };

  const handleShowPasswordReset = () => {
    setShowPasswordReset(true);
    setError(''); // Clear any existing errors
  };

  const handleBackToLogin = () => {
    setShowPasswordReset(false);
    setError(''); // Clear any existing errors
  };

  // If showing password reset, render that component instead
  if (showPasswordReset) {
    return <PasswordReset onBack={handleBackToLogin} />;
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/images/connectional-logo.svg" alt="Connectional" className="login-logo" />
        <h2>Welcome to Connectional</h2>
        <p className="login-subtitle">A Call Management Platform for the TWK</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            className="login-btn"
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        
        <div className="login-footer">
          <button 
            type="button" 
            onClick={handleShowPasswordReset}
            className="forgot-password-btn"
            disabled={loading}
          >
            Forgot your password?
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
